<div class="body">
    <app-shop-navbar [(cart)]="cart" class="navbar" (confirmOrderAnchor)="confirmOrder()"></app-shop-navbar>
    <app-shop-core [(cart)]="cart" (createShoppingCart)="createShoppingCart()" class="content"></app-shop-core>
</div>